import { render } from "./second-comp.vue?vue&type=template&id=4584555e&scoped=true"
import script from "./second-comp.vue?vue&type=script&lang=js"
export * from "./second-comp.vue?vue&type=script&lang=js"

import "./second-comp.vue?vue&type=style&index=0&id=4584555e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4584555e"]])

export default __exports__